'use client';

import { ISalePageDetailV2Response } from '@/api/types';
import { useSellerInfoQuery } from '@/entities/sellerInfo';
import { SalePagePurchaseGuideSections } from '../purchaseGuide/PurchaseGuideSection';
import {
  getBasicInfoItems,
  getDisplayMode,
  getOperationInfoItems,
} from './utils';

interface SellerInfoSectionProps {
  salePageId: number;
  salePage?: Partial<ISalePageDetailV2Response>;
  colorScheme?: 'default' | 'white';
  initialOpen?: boolean;
}

export const SellerInfoSection = ({
  salePageId,
  salePage,
  colorScheme,
  initialOpen,
}: SellerInfoSectionProps) => {
  const { data: sellerInfo } = useSellerInfoQuery(salePageId);

  if (!sellerInfo) return null;

  const displayMode = getDisplayMode(salePage);
  if (displayMode === 'HIDDEN') return null;

  const basicInfoItems = getBasicInfoItems(sellerInfo);
  const operationInfoItems = getOperationInfoItems(sellerInfo, salePage);

  const sections: { title?: string; description: string[] }[] = [];

  if (basicInfoItems.length > 0) {
    sections.push({
      title: '판매자 기본 정보',
      description: basicInfoItems,
    });
  }

  if (operationInfoItems.length > 0) {
    sections.push({
      title: '판매자 운영 정보',
      description: operationInfoItems,
    });
  }

  if (sections.length === 0) return null;

  return (
    <SalePagePurchaseGuideSections
      title="판매 정보"
      sections={sections}
      colorScheme={colorScheme}
      initialOpen={initialOpen}
    />
  );
};
